/*******************************************************************
 * ADOBE CONFIDENTIAL
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import {Skeleton} from '@nest/utility/src/skeleton/Skeleton';
import './AssistantSkeleton.scss';

export class AssistantSkeleton extends Skeleton {
	static aupSkillCard(): string {
		return `
			<div class="skl-assistant-aup-card">
				${this.rect({width: '70%', height: '14px'})}
				${this.rect({width: '50%', height: '14px'})}
			</div>
		`;
	}

	static toString(): string {
		return this.wrapper({
			className: 'skl-assistant-aup',
			children: `
				<div class="skl-assistant-aup__header">
					<div class="skl-assistant-aup__header-sidebar">
						${this.rect({width: '90px', height: '16px'})}
						${this.rect({width: '36px', height: '20px'})}
						<div style="flex:1"></div>
						${this.rect({width: '20px', height: '20px'})}
					</div>
					<div class="skl-assistant-aup__header-main">
						${this.rect({width: '110px', height: '32px'})}
					</div>
				</div>
				<div class="skl-assistant-aup__body">
					<div class="skl-assistant-aup__sidebar">
						${this.rect({width: '100%', height: '36px'})}
						<div class="skl-assistant-aup__recents-label">
							${this.rect({width: '60px', height: '12px'})}
						</div>
						<div class="skl-assistant-aup__history">
							${this.rect({width: '100%', height: '36px'})}
							${this.rect({width: '100%', height: '36px'})}
							${this.rect({width: '85%', height: '36px'})}
						</div>
					</div>
					<div class="skl-assistant-aup__main">
						<div class="skl-assistant-aup__hero">
							${this.rect({width: '80%', height: '44px'})}
						</div>
						<div class="skl-assistant-aup__prompt">
							${this.rect({width: '100%', height: '130px'})}
						</div>
						<div class="skl-assistant-aup__skill-cards">
							${this.aupSkillCard()}
							${this.aupSkillCard()}
							${this.aupSkillCard()}
							${this.aupSkillCard()}
							${this.aupSkillCard()}
							${this.aupSkillCard()}
							${this.aupSkillCard()}
							${this.aupSkillCard()}
						</div>
					</div>
				</div>
			`,
		});
	}
}
